module.exports = "<div class=\"navbar navbar-expand navbar-dark flex-column flex-md-row\">\r\n    <img id=\"cuadro-redondo\" src=\"../../assets/imagenes/LogoOep.png\" alt=\"Logo\"> \r\n    <div class=\"mx-auto text-center\">      \r\n        <h1 class=\"navbar-nav-scroll\"><strong>Consulta de Trámites</strong></h1>  \r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cabezera/cabezera.component.html
// module id = ./src/app/cabezera/cabezera.component.html
// module chunks = main